import * as React from 'react';

import SortableTable from 'components/sortable-table/SortableTable';

import ShippingAddressesName from './name/ShippingAddressesName';
import ShippingAddressesCopyAddressIcon from './copy-address/ShippingAddressesCopyAddressIcon';
import ShippingAddressesPhone from './ShippingAddressesPhone';
import ShippingAddressesShippingAddress from './ShippingAddressesShippingAddress';

import { t } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import type { ShippingAddress, SubcampaignInfluencerProfile } from 'types';

import './shipping-addresses.scss';

export type AddressEntry = {
  id: number,
  subcampaignId: number,
  creatorProfile: SubcampaignInfluencerProfile,
  shippingAddress: ShippingAddress | undefined | null,
  dateOfFirstTask: Date | undefined | null
};

type Props = {
  campaignId: number,
  entries: Array<AddressEntry>
};

class ShippingAddresses extends React.Component<Props> {
  render() {
    const { campaignId } = this.props;

    const columns = [
      {
        title: t('shipping_addresses.column_title_name'),
        key: 'name',
        sort: (a, b) => a.creatorProfile.name.localeCompare(b.creatorProfile.name),
        render: ({ creatorProfile, subcampaignId }) =>
          <div className="shipping-addresses__cell--block">
            <ShippingAddressesName
              campaignId={campaignId}
              subcampaignId={subcampaignId}
              influencer={creatorProfile}
            />
          </div>
      },
      {
        title: t('shipping_addresses.column_title_shipping_address'),
        key: 'shipping_address',
        render: ({ shippingAddress, subcampaignId }) =>
          <ShippingAddressesShippingAddress
            shippingAddress={shippingAddress}
            rowIndex={subcampaignId}
          />
      },
      {
        title: t('shipping_addresses.column_title_email_address'),
        key: 'email_address',
        render: ({ shippingAddress }) => (
          <div className="shipping-addresses__cell--centered">
            {shippingAddress?.email || '–'}
          </div>
        )
      },
      {
        title: t('shipping_addresses.column_title_phone_number'),
        key: 'phone_number',
        render: ({ shippingAddress }) =>
          <div className="shipping-addresses__cell--centered">
            <ShippingAddressesPhone shippingAddress={shippingAddress} />
          </div>
      },
      {
        title: t('shipping_addresses.column_title_date_first_task'),
        key: 'date_first_task',
        sort: (a, b) => ((a.dateOfFirstTask > b.dateOfFirstTask) ? 1 : -1),
        render: ({ dateOfFirstTask }) => (
          <div className="shipping-addresses__cell--centered">
            {(dateOfFirstTask) ? getDisplayDate(dateOfFirstTask) : '–'}
          </div>
        )
      },
      {
        title: '',
        key: 'download',
        className: 'shipping-addresses__download-column',
        render: ({ subcampaignId }) =>
          <div className="shipping-addresses__cell--centered">
            <ShippingAddressesCopyAddressIcon rowIndex={subcampaignId} />
          </div>
      }
    ];

    return (
      <div className="shipping-addresses__module">
        <SortableTable
          columns={columns}
          data={this.props.entries}
          layout="dense"
        />
      </div>
    );
  }
}

export default ShippingAddresses;
